<template>
  <el-dialog
    title="价格方案详情"
    :visible.sync="dialogVisible"
    width="700px"
    :before-close="handleClose"
    @close="handleClose"
    class="price-detail-dialog"
  >
    
    <div v-if="priceInfo" class="price-info">
      <el-card class="info-card" shadow="never">
        <div slot="header" class="card-header">
          <span>基础信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="info-item">
              <span class="info-label">价格方案名称：</span>
              <span class="info-value">{{ priceInfo.name }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="info-item">
              <span class="info-label">公司名称：</span>
              <span class="info-value">{{ priceInfo.company_name }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="info-item">
              <span class="info-label">签署协议的公司名称：</span>
              <span class="info-value">{{ priceInfo.company_name }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="info-item">
              <span class="info-label">保险公司类型：</span>
              <span class="info-value">{{ formatInsuranceType(priceInfo.insurance_type) }}</span>
            </div>
          </el-col>
        </el-row>
      </el-card>
      
      <el-card class="info-card" shadow="never" style="margin-top: 20px;">
        <div slot="header" class="card-header">
          <span>费用信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="info-item">
              <span class="info-label">费率：</span>
              <span class="info-value rate-value">{{ formatPremiumRate(priceInfo.premium_rate) }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="info-item">
              <span class="info-label">最低保费：</span>
              <span class="info-value money-value">{{ formatMoney(priceInfo.min_premium) }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="info-item">
              <span class="info-label">最高保险限额：</span>
              <span class="info-value money-value">{{ formatMoney(priceInfo.max_coverage) }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="info-item">
              <span class="info-label">协议扫描件：</span>
              <span class="info-value">
                <el-link 
                  v-if="priceInfo.protocol_url" 
                  :href="priceInfo.protocol_url" 
                  target="_blank" 
                  type="primary"
                >
                  查看协议
                </el-link>
                <span v-else class="no-data">无</span>
              </span>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
    
    <div v-else class="no-data-tip">
      暂无价格方案信息
    </div>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="medium">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { formatMoney } from '@/utils/formatter'
import { getWccyrPriceInfo } from '@/api/member'

export default {
  name: 'WccyrPriceDetail',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    priceId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      priceInfo: null,
      loading: false
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        // 获取价格方案详情
        this.fetchPriceInfo()
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    formatMoney,
    formatInsuranceType(value) {
      const insuranceTypeMap = {
        1: '太平保险公司',
        2: '大地保险公司'
      }
      return insuranceTypeMap[value] || '未知'
    },
    formatPremiumRate(value) {
      if (!value) return ''
      return (value / 10000) + '%'
    },
    // 获取价格方案详情
    async fetchPriceInfo() {
      if (!this.priceId) {
        this.priceInfo = null
        return
      }
      
      this.loading = true
      try {
        // 调用获取价格方案详情的API
        const res = await getWccyrPriceInfo({ id: this.priceId })
        if (res.err_code === 0) {
          this.priceInfo = res.data
        } else {
          console.error('获取价格方案详情失败:', res.err_msg)
          this.$message.error('获取价格方案详情失败: ' + res.err_msg)
          this.priceInfo = null
        }
      } catch (error) {
        console.error('获取价格方案详情失败:', error)
        this.$message.error('获取价格方案详情失败')
        this.priceInfo = null
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.price-detail-dialog {
  /deep/ .el-dialog__body {
    padding: 20px 30px;
  }
  
  .info-card {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    
    .card-header {
      padding: 10px 20px;
      background-color: #f5f7fa;
      border-bottom: 1px solid #ebeef5;
      
      span {
        font-weight: 600;
        color: #303133;
      }
    }
    
    .info-item {
      display: flex;
      padding: 12px 0;
      min-height: 40px;
      align-items: center;
      
      .info-label {
        width: 150px;
        text-align: right;
        color: #606266;
        font-size: 14px;
        flex-shrink: 0;
      }
      
      .info-value {
        flex: 1;
        color: #303133;
        font-size: 14px;
        word-break: break-all;
        padding-left: 10px;
        
        &.rate-value {
          color: #e6a23c;
          font-weight: 500;
        }
        
        &.money-value {
          color: #67c23a;
          font-weight: 500;
        }
        
        .no-data {
          color: #909399;
        }
      }
    }
  }
  
  .no-data-tip {
    text-align: center;
    padding: 40px 0;
    color: #909399;
    font-size: 14px;
  }
  
  .dialog-footer {
    text-align: center;
    padding: 20px 0 0;
  }
}
</style>